var render = function render(_c,_vm){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.props.width || 24,"height":_vm.props.height || 24,"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z","fill":_vm.props.fill || '#bababa'}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0V0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }